<template>
    <MaintenanceRequest></MaintenanceRequest>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const MaintenanceRequest = defineAsyncComponent(() =>
    import("../../components/Facilities/MaintenanceRequest.vue")
);

export default {
    name: "Maintenance_Request", //The name you are in should not equal the name of the component you are importing.
    components: { MaintenanceRequest, AuthLayout },
};
</script>
